import { render, staticRenderFns } from "./AgendaIframe.vue?vue&type=template&id=81e0a25e&scoped=true&"
import script from "./AgendaIframe.vue?vue&type=script&lang=js&"
export * from "./AgendaIframe.vue?vue&type=script&lang=js&"
import style0 from "./AgendaIframe.vue?vue&type=style&index=0&id=81e0a25e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e0a25e",
  null
  
)

export default component.exports